/**
 * Single source of truth for LaunchDarkly flag defaults.
 * No imports — safe to use in both browser and Node (build-time) contexts.
 * `launch-darkly-config.ts` re-exports this for the app.
 * Fixture files import this directly for screenshot generation.
 */
export const fallbackFlags = {
  // operational
  'show-application-maintenance-mode': false,
  'show-price-cap': false,
  'show-operational-alert': false,
  'show-cross-sell-offer': false,

  // journeys
  'allow-journey-default': true,
  'allow-journey-voicesales-homemove': true,
  'allow-journey-voicesales-winback': true,
  'allow-journey-voicesales-aquisition': true,
  'allow-journey-nondomestic-transfer': true,
  // release
  'release-solar-registration': false,
  'release-abandoned-cart': false,
  'release-ev-quote': false,
  'release-ev-quote-voice-sales': false,
  'release-peak-save-journey': false,
  'release-ev-info-redesign': false,
  'release-update-meter-reading-frequency-question': false,
  'release-winback-remove-bill-credit-dropdown': false,
  'release-fnf-voice-sales-description': false,
  'release-vat-removal-message': false,
  'release-low-standing-charge-tariff': false,
  'release-cap-tracker-filter': false,
  'release-vat-copy-update': false,
  'release-decide-later-improvements': false,
  'release-fix-and-fall-october': false,
  'release-voice-sales-consent-copy': false,
  'release-missing-address-dialler-campaign-integration': false,
  'release-request-callback-lead': false,
  'release-pill-position-and-copy-update': false,
  'release-vat-copy-update-two': false,
  'release-til-page-exit-fee-caveat-removal': false,
  'release-email-quote-copy-updates': false,
  'release-agent-new-intro-copy': false,

  // experiment
  'experiment-direct-debit-new-validation': false,
  'experiment-early-exit-update': false,
  'experiment-price-sensitivity-quote': false,
  'experiment-exit-fee-wording': false,
  'experiment-electralink': {
    value: 'A'
  },
  'experiment-two-tariff-view': false,
  'experiment-pds-api': false
} as const;
